import * as isPlainObject from 'is-plain-object';
export var isDebuggingEnabled = function () {
    var search = window.location.search;
    return search.substring(1).split('&').includes('debug=true');
};
export var isDev = function () { return process.env.isDev || isDebuggingEnabled(); };
export var isAdminSite = function () {
    var regex = /^(dashboard|admin([0-9]+)?)\.[0-9a-z].*/gm;
    return !isNull(regex.exec(window.location.host));
};
export var isWebView = function () { return window.navigator.userAgent.indexOf('MTWebView') > -1; };
export var isObject = function (obj) { return isPlainObject.isPlainObject(obj); };
export var isUndefined = function (value) { return typeof value === 'undefined'; };
export var isPrunable = function (elem) { return Array.isArray(elem) || isObject(elem); };
export var hasValue = function (elem) { return !(isUndefined(elem) || elem === null); };
export var isNull = function (value) { return value === null; };
export var isString = function (value) { return typeof value === 'string'; };
export var prune = function (elem) {
    if (!isPrunable(elem))
        return elem;
    if (Array.isArray(elem)) {
        return elem.reduce(function (acc, val) {
            if (hasValue(val)) {
                var newVal = isPrunable(val) ? prune(val) : val;
                acc.push(newVal);
            }
            return acc;
        }, []);
    }
    if (isObject(elem)) {
        return Object.keys(elem).reduce(function (acc, key) {
            var val = elem[key];
            if (hasValue(val)) {
                var newVal = isPrunable(val) ? prune(val) : val;
                acc[key] = newVal;
            }
            return acc;
        }, {});
    }
};
function isNullOrUndefined(x) {
    return isUndefined(x) || isNull(x);
}
function isEmptyObject(x) {
    return isObject(x) && !Object.keys(x).length;
}
function isEmptyArray(x) {
    return Array.isArray(x) && !x.length;
}
export function isEmpty(x) {
    if (isEmptyObject(x) || isEmptyArray(x))
        return true;
    if (isString(x) && !x.length)
        return true;
    return isNullOrUndefined(x);
}
export function getHighResolutionTime() {
    var _a;
    var performanceTime = (_a = performance === null || performance === void 0 ? void 0 : performance.now) === null || _a === void 0 ? void 0 : _a.call(performance);
    if (isUndefined(performanceTime)) {
        return Date.now();
    }
    return performanceTime;
}
//# sourceMappingURL=index.js.map